import React from 'react';
import Header from "./Header/Header";
import FormInput from "./Form/Form";
import ImageCard from "./ImageCard/ImageCard";
import {Row} from "react-bootstrap";

function MainBody() {
    return (
        <Row className='pt-2'>
            {/*<Col>*/}
                <Header/>

                <h3 className={`pt-4`}>Welcome, Find a flexible flight for your next trip</h3>

                {/************ FormInput *************************/}
                <FormInput/>

                {/************ Image Card *************************/}
                <ImageCard/>
            {/*</Col>*/}
        </Row>
    );
}

export default MainBody;
